<template>
    <div  class="flex justify-between
    border-b-4 border-warmGray-400 pt-3 bg-wamGray-200 rounded-md">
         <button @click="prev=!prev"
         class="py-2 md:mr-2 md:px-2 cursor-pointer rounded-full
           border-solid border-2  border-warmGray-100 hover:bg-blue-100">
           <svg width="24" height="24" fill="none" viewBox="0 0 24 24"
              stroke="#065596"
              class="transform transition-transform duration-500 ease-in-out">
            <path stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 19l-7-7 7-7m8 14l-7-7 7-7"></path>
          </svg>
         </button>

      <router-link
      class="flex-grow px-2 md:px-3 py-3  shadow text-center
       text-sm md:text-base font-semibod text-gray-900 tracking-tighter
       md:tracking-normal  border-b border-warmGray-400"
                v-for="(value,  gIndex) in getCurGruppe" :key="gIndex"
                  :to="{
                    name: 'Home2',
                    params:{slug: getUrl(value) }
                }" v-html="value">
                           </router-link>
            <!-- </div> -->
             <button @click="next=!next" class="mr-2 md:p-2 cursor-pointer rounded-full
           border-solid border-2 text-center border-warmGray-100 hover:bg-blue-100">
           <!-- <a class="m-auto text-center align-middle" href="/"> -->
                  <svg width="24" height="24" fill="none" viewBox="0 0 24 24"
                   stroke="#065596"
                  class="transform transition-transform duration-500 ease-in-out ">
                  <path stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path>
                </svg>
                <!-- </a>mr-1  -->
             </button>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props: {
    gruppe: Object,
    gruppenUrls: Object
  },
  data () {
    return {
      loading: false,
      curPageNubmer: 0,
      numberPerRange: 3,
      prev: false,
      next: false,
      from: 0,
      to: this.numberPerRange,
      slug: this.$route.params.slug
    }
  },
  created () {
    this.loading = true
    this.$store.dispatch('setProductToStore')
    // this.$store.dispatch('fetchProducts')
      .then(
        () => {
          this.loading = false
          // console.log(this.slug)
        }
      )
  },
  computed: {
    getCurGruppe () {
      var curSlug = this.$route.params.slug
      if (this.prev) {
        this.get_prev_group()
        return this.gruppe.slice(this.from, this.to)
      }
      if (this.next) {
        this.get_next_group()
        return this.gruppe.slice(this.from, this.to)
      }
      this.determine_number_per_range()

      this.determine_from_to_range(curSlug)
      // if (this.next) {
      //   this.get_next_group()
      // }
      return this.gruppe.slice(this.from, this.to)
    }
  },
  methods: {
    ...mapActions([
      'createUrl'
    ]),
    getUrl: (word) => {
      return word.replace(' ', '-').trim()
    },

    determine_number_per_range () {
      const windowWidth = window.innerWidth
      // console.log('windowWidth: ' + windowWidth)
      var perRange = 3
      // console.log('windowWidth: ' + windowWidth)
      if (windowWidth < 550) {
        perRange = 3
        // console.log('xs')
      }
      if (windowWidth > 549 && windowWidth < 1200) {
        perRange = 6
        // console.log('md')
      }
      if (windowWidth > 1199) {
        // console.log('lg')
        perRange = 8
      }
      this.numberPerRange = perRange
    },
    determine_from_to_range (curSlug) {
      var from = this.from
      var perRange = this.numberPerRange
      var to = perRange
      if (to > this.gruppe.length) {
        from = 0
        to = this.gruppe.length
      }
      if (curSlug) {
        var curIdx = this.gruppenUrls.indexOf(curSlug)
        // console.log('slug: ' + curSlug + ', idx: ' + curIdx)
        if (curIdx <= 0) {
          from = 0
        } else {
          from = curIdx - Math.floor((perRange - 1) / 2)
          to = curIdx + Math.ceil((perRange - 1) / 2) + 1
        }
        if (from < 0) {
          from = 0
        }
        if (to >= this.gruppenUrls.length) {
          to = this.gruppenUrls.length
          from = to - perRange
        }
      }
      // console.log('from: ' + from + ', to: ' + to)
      this.from = from
      this.to = to
      // return rangeLimit
    },
    get_next_group () {
      if (this.next) {
        this.next = false
        var totalLength = this.gruppe.length
        this.next = false
        var nFrom = this.to
        var nTo = nFrom + this.numberPerRange
        if (nTo > totalLength) {
          nTo = totalLength
          nFrom = nTo - this.numberPerRange
        }
        this.from = nFrom
        this.to = nTo
      }
      // nFrom = 3
      // nTo = 6
      // console.log('get next: from: ' + nFrom + ', to ' + nTo)
    },
    get_prev_group () {
      if (this.prev) {
        this.prev = false
        var nTo = this.from
        var nFrom = nTo - this.numberPerRange
        if (nFrom < 0) {
          nFrom = 0
          nTo = nFrom + this.numberPerRange
        }
        this.from = nFrom
        this.to = nTo
      }
      // nFrom = 3
      // nTo = 6
      // console.log('get next: from: ' + nFrom + ', to ' + nTo)
    }
  }

}
</script>
<style scoped>

.Namaste-Food-Category{
  color:#dc143c;
  border-left: 2px solid#044cbe !important ;
  border-top: 2px solid #044cbe !important ;
  border-right: 2px solid #044cbe !important ;
  border-bottom: 1px solid rgb(242, 242, 252) !important ;
  font-weight: bold;
  border-radius: 0.22rem;
  margin:auto;
  text-align: center;
}
.Namaste-Food-Category:parent{

  border: 2px solid rgb(13, 13, 233) !important ;
}
</style>
